var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99994 9.63333L2.28327 15.35C2.06938 15.5639 1.79716 15.6708 1.4666 15.6708C1.13605 15.6708 0.863824 15.5639 0.649935 15.35C0.436046 15.1361 0.329102 14.8639 0.329102 14.5333C0.329102 14.2028 0.436046 13.9306 0.649935 13.7167L6.3666 8L0.649935 2.28333C0.436046 2.06944 0.329102 1.79722 0.329102 1.46666C0.329102 1.13611 0.436046 0.863885 0.649935 0.649996C0.863824 0.436107 1.13605 0.329163 1.4666 0.329163C1.79716 0.329163 2.06938 0.436107 2.28327 0.649996L7.99994 6.36666L13.7166 0.649996C13.9305 0.436107 14.2027 0.329163 14.5333 0.329163C14.8638 0.329163 15.136 0.436107 15.3499 0.649996C15.5638 0.863885 15.6708 1.13611 15.6708 1.46666C15.6708 1.79722 15.5638 2.06944 15.3499 2.28333L9.63327 8L15.3499 13.7167C15.5638 13.9306 15.6708 14.2028 15.6708 14.5333C15.6708 14.8639 15.5638 15.1361 15.3499 15.35C15.136 15.5639 14.8638 15.6708 14.5333 15.6708C14.2027 15.6708 13.9305 15.5639 13.7166 15.35L7.99994 9.63333Z",
    fill: "#364144"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.2d183dc8c75b722e55827d728cbd2a00.svg";
export { ForwardRef as ReactComponent };